import React from "react";
import { Button } from "@/components/ui/button";
import { AlertCircle } from "lucide-react";

export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, info) {
    // eslint-disable-next-line no-console
    console.error("[ErrorBoundary]", error, info);
  }

  reset = () => {
    this.setState({ hasError: false, error: null });
  };

  render() {
    if (this.state.hasError) {
      return (
        <div className="min-h-[60vh] flex items-center justify-center p-6" data-testid="error-boundary">
          <div className="max-w-md text-center">
            <AlertCircle className="w-12 h-12 text-red-500 mx-auto mb-3" />
            <div className="font-display text-2xl font-bold text-slate-900">Algo deu errado nesta tela</div>
            <div className="text-sm text-slate-500 mt-2">
              {this.state.error?.message || "Erro inesperado."}
            </div>
            <div className="flex gap-2 justify-center mt-4">
              <Button
                variant="outline"
                onClick={() => { this.reset(); window.location.reload(); }}
                data-testid="err-reload"
              >
                Recarregar
              </Button>
              <Button
                onClick={() => { this.reset(); window.location.href = "/funil"; }}
                data-testid="err-home"
              >
                Voltar ao Funil
              </Button>
            </div>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}
